import { Link,
  TableCellText,
} from "@ceridianhcm/components";

export const YearEndColumnsDefinitions = (
  onReportClick: (rowData: any) => void
) => {

  return [
    {
      field: "fileName",
      label: "File Name",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.fileName}>
            {cellContext.rowData.fileName}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "RunDate",
      label: "Run Date",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.RunDate}>
            {cellContext.rowData.RunDate}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "taxYear",
      label: "Tax Year",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.taxYear}>
            {cellContext.rowData.taxYear}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "companyName",
      label: "Company Name",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.companyName}>
            {cellContext.rowData.companyName}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "t4SlipCount",
      label: "Total SlipCount",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.t4SlipCount}>
            {cellContext.rowData.t4SlipCount}
          </div>
        </TableCellText>
      ),
    },
     {
          field: "yearEndReport",
          label: "Year-End Report",
          cellTemplate: (cell: any) => {
            return (
              <Link
                id={`yearEndReport-${cell.rowData.fileName}`}
                 onClick={(e) => {
                e.preventDefault();
                onReportClick(cell.rowData);
              }}               
                variant="neutral"
                testId={`yearEndReport-${cell.rowData.fileName}`}
              >
                <div title={`YearEnd Report`}>{`YearEnd Report`}</div>
              </Link>
            );
          },
        },

  
  ];
};
